import { useState, useEffect, useRef } from 'react';
import './Asset/Font-family/GoodTimesRg-Regular.ttf';
import './Asset/Font-family/GoodTimesRg-Regular.woff';
import './Asset/Font-family/GoodTimesRg-Regular.eot';
import Header from './Layouts/UserLayout/Header';
import Sidebar from './Layouts/UserLayout/Sidebar';
import Futter from './component/Futter';
import GoToTop from './component/GoToTop';
import { Outlet, useLocation } from 'react-router-dom';
import Layout from './Layout';
import { ToastContainer } from 'react-toastify';

function App({ children }) {
	const location = useLocation();
	const [isCollapsed, setIsCollapsed] = useState(false);
	const [isHovered, setIsHovered] = useState(false);
	const [isSidebarVisible, setIsSidebarVisible] = useState(window.innerWidth > 991);

	const sidebarRef = useRef(null);

	const toggleSidebar = event => {
		event.stopPropagation(); // Stop the click event from propagating
		setIsSidebarVisible(!isSidebarVisible);
	};

	const handleOutsideClick = event => {
		if (window.innerWidth > 991) {
			setIsSidebarVisible(isSidebarVisible);
		} else if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
			// Clicked outside the sidebar, so close it
			setIsSidebarVisible(false);
		}
	};

	useEffect(() => {
		const handleResize = () => {
			setIsSidebarVisible(window.innerWidth > 991);
		};
		handleResize();
		window.addEventListener('resize', handleResize);

		// Cleanup the event listener on component unmount
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		if (isSidebarVisible && location.pathname.startsWith('/PlayerPage')) {
			setIsCollapsed(true);
		} else {
			setIsCollapsed(false);
		}
	}, [location.pathname]);

	useEffect(() => {
		if (isSidebarVisible) {
			window.addEventListener('click', handleOutsideClick);
		} else {
			window.removeEventListener('click', handleOutsideClick);
		}

		return () => {
			window.removeEventListener('click', handleOutsideClick);
		};
	}, [handleOutsideClick, isSidebarVisible]);

	return (
		<Layout>
			<div>
				<Header HideSideBar={toggleSidebar} />
				<section className="c-full_body row m-0 p-0">
					{isSidebarVisible && (
						<div
							className={`c-side_bar p-0 ${isCollapsed ? 'collapsed' : ''}`}
							onMouseEnter={() => setIsHovered(true)}
							onMouseLeave={() => setIsHovered(false)}
							ref={sidebarRef}
						>
							<Sidebar
								closeCallback={() => {
									if (window.innerWidth < 991) {
										setIsSidebarVisible(false);
									}
								}}
								isSidebarCollapsed={isCollapsed && !isHovered ? true : false}
							/>
						</div>
					)}
					{isCollapsed && isHovered && <div className="c-overlay" />}
					<div className={`c-body_section ${isCollapsed ? 'collapsed' : ''}`}>
						{children ? children : <Outlet />}
						<Futter />
					</div>
				</section>
				<ToastContainer />
				<GoToTop />
			</div>
		</Layout>
	);
}

export default App;
